import { render } from "./EditPKOModal.vue?vue&type=template&id=2516b200&scoped=true"
import script from "./EditPKOModal.vue?vue&type=script&lang=js"
export * from "./EditPKOModal.vue?vue&type=script&lang=js"

import "./EditPKOModal.vue?vue&type=style&index=0&id=2516b200&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2516b200"]])

export default __exports__